module.exports = function(itemId, cb) {
    this._sendMessage('getWidgetFromItem', {itemId: itemId});

    this._onGetCallback = cb;
};